import _styled, { default as _styled2 } from "styled-components";
var _templateObject;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
/* istanbul ignore file */

import React from 'react';
import { IconPaymentAmex, IconPaymentApplePay, IconPaymentKlarna, IconPaymentMastercard, IconPaymentPayPal, IconPaymentVisa } from '@noths/polaris-client-ribbons-design-system';
import * as styles from "./FooterPayment.styles";
export var FooterPayment = function FooterPayment() {
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(_StyledSpan, {
    $_css: styles.screenReaderOnly
  }, "Available payment methods:"), /*#__PURE__*/React.createElement(_StyledUl, {
    $_css2: styles.list
  }, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(IconPaymentVisa, {
    height: "32",
    width: "50"
  })), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(IconPaymentMastercard, {
    height: "32",
    width: "50"
  })), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(IconPaymentAmex, {
    height: "32",
    width: "50"
  })), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(IconPaymentPayPal, {
    height: "32",
    width: "50"
  })), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(IconPaymentApplePay, {
    height: "32",
    width: "50"
  })), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(IconPaymentKlarna, {
    height: "32",
    width: "50"
  }))));
};
var _StyledSpan = _styled("span")(_templateObject || (_templateObject = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css;
});
var _StyledUl = /*#__PURE__*/_styled2("ul").withConfig({
  displayName: "FooterPayment___StyledUl",
  componentId: "sc-1005bow-0"
})(["", ""], function (p) {
  return p.$_css2;
});